module.exports = __webpack_public_path__ + "img/导航栏_logo.24a39d2f.png";